export const checkEmptyString = (value: string | null): string | null => {
  const baseValue = value === '' ? null : value;
  if (typeof baseValue === 'string') {
    return baseValue.trim();
  }
  return baseValue;
};
